module.exports = __webpack_public_path__ + "img/icon-popup-close.5e34a452.svg";